/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_Stage_ChecksInputs */

const en_directory_hubs_signals_ai_stage_checks = /** @type {(inputs: Directory_Hubs_Signals_Ai_Stage_ChecksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`checks`)
};

const zh_directory_hubs_signals_ai_stage_checks = /** @type {(inputs: Directory_Hubs_Signals_Ai_Stage_ChecksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项检查`)
};

/**
* | output |
* | --- |
* | "checks" |
*
* @param {Directory_Hubs_Signals_Ai_Stage_ChecksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_stage_checks = /** @type {((inputs?: Directory_Hubs_Signals_Ai_Stage_ChecksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_Stage_ChecksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_stage_checks(inputs)
	return zh_directory_hubs_signals_ai_stage_checks(inputs)
});
export { directory_hubs_signals_ai_stage_checks as "directory.hubs.signals.ai.stage.checks" }